import { useEffect, useState } from 'react';
import React from 'react';
import styled from 'styled-components';
import { IBlogContent } from '@/types/blog';

export const TableContent = ({ data = [] }: { data: IBlogContent[] }) => {
  const [activeSection, setActiveSection] = useState('');

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;

      data.forEach((item, index) => {
        const element = document.getElementById(item.title);
        if (element) {
          const { offsetTop } = element;
          const nextElement =
            index < data.length - 1
              ? document.getElementById(data[index + 1].title)
              : null;
          const nextElementTop = nextElement ? nextElement.offsetTop : Infinity;

          if (scrollPosition >= offsetTop && scrollPosition < nextElementTop) {
            setActiveSection(item.title);
          }
        }
      });
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [data]);

  const scrollToElement = (e, id) => {
    e.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      });
    }
  };

  return (
    <Wrapper>
      <Title>Table content</Title>
      <ListItems>
        {data
          .filter((item) => !!item.title)
          ?.map((item, idx) => (
            <Item isActive={activeSection === item.title} key={idx}>
              <h2
                className={activeSection === item.title ? 'active' : ''}
                onClick={(e) => scrollToElement(e, item.title)}
              >
                {item.title}
              </h2>
            </Item>
          ))}
      </ListItems>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  border: 1px solid rgba(219, 224, 239, 1);
  padding: 24px 24px 24px 0;
  border-radius: 10px;
`;

const Title = styled.h2`
  font-size: 24px;
  line-height: 32px;
  text-align: left;
  margin-bottom: 24px;
  padding-left: 24px;
`;

const ListItems = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: column;
`;

const Item = styled.li<{ isActive: boolean }>`
  display: flex;
  align-items: center;
  transition: all 0.2s;
  cursor: pointer;
  & h2 {
    padding-left: 24px;
    font-family: var(--font-roboto);
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: left;
    color: rgba(77, 77, 77, 1);
  }

  &:hover {
    color: rgba(32, 111, 237, 1);
    transition: all 0.2s;
  }
  & .active {
    color: rgba(32, 111, 237, 1);
  }
  &::before {
    content: '';
    display: block;
    width: 4px;
    height: 40px;
    border-radius: 0px 4px 4px 0px;
    transition: all 0.2s;
    background-color: ${(props) =>
      props.isActive ? 'rgba(32, 111, 237, 1)' : 'transparent'};
  }
`;
